import axios from 'axios';
import { useQuery } from 'react-query';
import { ThemesResponseDto } from '../model/types';

const THEMES_URL = `/api/admin/themes/`;

export const useGetThemes = () => {
	return useQuery<ThemesResponseDto>(
		['themes'],
		async () => {
			const { data } = await axios.get(THEMES_URL, {
				params: { limit: 100 },
			});
			return data;
		},
		{
			refetchOnWindowFocus: false,
		}
	);
};
